import { render, staticRenderFns } from "./DiagnosisSuggestField.vue?vue&type=template&id=78513097"
import script from "./DiagnosisSuggestField.vue?vue&type=script&lang=js"
export * from "./DiagnosisSuggestField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports